module.exports = __webpack_public_path__ + "static/img/bottom-02.2470d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom-02.png
// module id = aXRJ
// module chunks = 1